import React, { forwardRef } from 'react';
import { ButtonGroup, Button as CButton, ButtonProps as CButtonProps } from '@chakra-ui/react';
import classnames from 'classnames';
import styles from './Button.module.scss';

export interface ButtonProps extends CButtonProps {
  label?: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'primary';
  transparent?: boolean;
  icon?: React.ReactNode;
  // Anchor attributes, used when rendered with `as="a"`
  href?: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}

export { ButtonGroup };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, label, size = 'sm', type = 'button', transparent, children, icon, ...props }, ref) => (
    <CButton
      className={classnames(
        styles.container,
        {
          [styles.submit]: type === 'submit',
          [styles.button]: type === 'button',
          [styles.reset]: type === 'reset',
          [styles.colorPrimary]: props.color === 'primary',
          [styles.transparent]: !!transparent,
          ...(icon
            ? {
                [styles.iconButton]: !(children || label),
                'flex items-center': !!(children || label),
                'gap-1': size === 'sm' || size === 'xs',
                'gap-2': size === 'md' || size === 'lg',
              }
            : {}),
        },
        className,
      )}
      type={type}
      size={size}
      ref={ref}
      {...props}
    >
      {icon}
      {children || label}
    </CButton>
  ),
);
